/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/

// System defined variables
import React, { useState, useEffect } from 'react'
import { Search } from 'semantic-ui-react' //Grid
import _ from 'lodash'
import { useNavigate, useLocation } from 'react-router-dom'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'
import {
  useRecoilState,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState,
} from 'recoil'

// Custom defined variables.
import SearchIcon from '../../../../assets/images/Search.svg'
import ReactModal from '../../base/modal/ReactModal'
import APIEndPoints from '../../../../models/api/apiEndpoints'
import { fetchDataSelector } from '../../recoil/selectors/selectors'
import {
  toastMessage,
  selectedCaseDetails,
  madeChanges,
  additionalOptionsDisabled,
  showLoading,
  selectedContractDetails,
  selectLinkedCaseDetails, //selectLinkedCaseDetails-> this atom wll not used in future as we going to use queryParams for case id -> linked case will also follow browser history.
  searchListFormGridData,
  selectedJobDetails,
  poundDetailsAtom,
  jobStepper,
  lastPathName,
  mappedUserRoles,
  caseOverviewTabSelectedIndexAtom,
  userDetail,
  accessibleUserForClampAndRemoval,
  invalidatePcnData,
  jobTabIndex,
  poundTabIndex,
  searchingJobIdData,
} from '../../recoil/atoms/atoms'

import utils from '../../../../utils/utils'

import './SearchBar.css'

function SearchBar({ SearchName }) {
  // onClick
  const initialState = {
    isLoading: false,
    result: [],
    value: '',
    dataSource: [],
    searchName: SearchName,
    errMsg: '',
    modalOpen: false,
    searchtext: null,
  }

  const navigate = useNavigate()
  const location = useLocation()
  const [state, setState] = React.useState(initialState)
  const [searchTearm, setsearchTearm] = React.useState(state.value)
  const getCoreData = useRecoilValue(fetchDataSelector)
  const [hasChanges, setChangesMade] = useRecoilState(madeChanges)
  const showToastMessage = useSetRecoilState(toastMessage)
  const [searclick, setSearchClick] = useState({ searchstate: false })
  const setSelectedcaseDetails = useSetRecoilState(selectedCaseDetails)
  const showLoader = useSetRecoilState(showLoading)
  const setAdditionalOptionsDisabled = useSetRecoilState(
    additionalOptionsDisabled
  )
  const setLastPathName = useSetRecoilState(lastPathName)
  const selectedContract = useRecoilValue(selectedContractDetails)
  const [selectLinkedCaseDetailsData, setSelectLinkedCaseDetails] =
    useRecoilState(selectLinkedCaseDetails)
  const [selectSearchListFormGridData, setSearchListFormGridData] =
    useRecoilState(searchListFormGridData)
  const setJobDetails = useSetRecoilState(selectedJobDetails)
  const setPoundDetails = useSetRecoilState(poundDetailsAtom)
  const setJobStepper = useSetRecoilState(jobStepper)
  const resetCaseOverviewTabSelectedIndex = useResetRecoilState(
    caseOverviewTabSelectedIndexAtom
  )
  const userDataItems = useRecoilValue(userDetail)
  const setAccessibleUserForClampAndRemoval = useSetRecoilState(
    accessibleUserForClampAndRemoval
  )
  const setRefreshPcnData = useSetRecoilState(invalidatePcnData)
  const setJobIndex = useSetRecoilState(jobTabIndex)
  const setPoundIndex = useSetRecoilState(poundTabIndex)
  const [jobIdData, setJobIdData] = useRecoilState(searchingJobIdData)

  const staticValues = {
    enterValidData: 'Please enter valid data',
    impoundJobState: 'impounded',
    eligibleForDisclaimJobState: 'eligiblefordisclaim',
    releasedJobState: 'released',
    disposal: 'disposed',
    cancelled: 'cancelled',
    superAdminContractId: 0,
  }

  const handleResultSelect = (e, { result }) => {
    state?.dataSource?.length > 0
      ? state?.dataSource?.forEach((item) => {
          const data = item[Object.keys(item)]
          const newdata = data?.results?.find(
            (item1) => item1.id === result?.id
          )
          if (typeof newdata !== 'undefined') {
            //searchdata = data
            return true
          }
        })
      : ''
  }

  const handleSearchChange = async (e, { value }) => {
    setState({
      isLoading: true,
      result: [],
      value: value,
      searchName: value,
      errMsg: '',
    })
    setsearchTearm(value)
  }
  //searchName
  const { isLoading, value, result, errMsg } = state

  //This function active for only enter key
  function listenEnter(e) {
    const searchValue = e.target.value
    if (e.key?.toString()?.toLowerCase() === 'enter') {
      //onClick(searchValue)
      if (
        searchTearm === '' ||
        searchTearm?.toString()?.length === 0 ||
        searchValue?.toString()?.toLowerCase() === 'undefined'
      ) {
        showToastMessage({
          message: utils?.fpnBasedChanges?.invalidGlobalSearch,
          status: utils?.toastStatus?.error,
        })
      } else {
        // Clear only the input display; keep searchTearm for the running search.
        setState((prevData) => ({
          ...prevData,
          value: '',
          searchName: '',
          result: [],
          errMsg: '',
        }))
        showLoader(true)
        setTimeout(() => {
          handleSearchResult()
        }, 1000)
      }
    }
  }

  const handleSearchResult = () => {
    if (
      searchTearm === null ||
      searchTearm === '' ||
      searchTearm?.toString()?.length === 0 ||
      _.isUndefined(searchTearm)
    ) {
      showToastMessage({
        message: utils?.fpnBasedChanges?.invalidGlobalSearch,
        status: utils?.toastStatus?.error,
      })
    } else {
      setSearchClick((prevstate) => ({
        ...prevstate,
        searchstate: !prevstate.searchstate,
      }))
    }
  }

  const onCleartextBoxValue = () => {
    setState((prevData) => ({
      ...prevData,
      value: '',
      searchName: '',
      result: [],
      errMsg: '',
      modalOpen: false,
      searchtext: null,
      isLoading: false,
    }))
    setsearchTearm('')
    if (location?.pathname === '/lockedcase' && location?.state?.lockMessage) {
      navigate('/lockedcase', { replace: true, state: {} })
    }
  }

  React.useEffect(() => {
    /* istanbul ignore next */
    let isGivenValueAlphaNumeric = /^[a-zA-Z0-9 ]+$/

    if (searchTearm !== '') {
      let getSearchData = null
      if (isNaN(searchTearm) && isGivenValueAlphaNumeric?.test(searchTearm)) {
        getSearchData = async () => {
          const filteredResults = []
          const searchData = await getCoreData(
            APIEndPoints.getSearchBarData.method,
            `${APIEndPoints.getSearchBarData.url}`,
            {
              contractId: selectedContract?.contractId || 0,
              searchText: searchTearm,
            }
          )

          if (searchData?.status === utils?.apiResponseCode?.successCode) {
            //below the useEffect if any select linked case tab store that case in below the state and when search click menu item will reset atoms value
            if (selectLinkedCaseDetailsData?.length > 0) {
              setSelectLinkedCaseDetails([])
            }
            if (selectSearchListFormGridData?.length > 0) {
              setSearchListFormGridData([])
            }
            if (searchData && searchData?.data && searchData?.data?.isVRM) {
              setState((Prev) => ({
                ...Prev,
                modalOpen: true,
                isLoading: false,
                result: filteredResults,
                dataSource: searchData && searchData?.data?.caseDetails,
                searchtext: searchTearm,
                // Clear the input text but keep the modal open with results
                value: '',
                searchName: '',
                errMsg: '',
              }))
              setsearchTearm('')
              showLoader(false)
            } else {
              if (searchData?.data?.caseDetails?.length > 0) {
                const selectedCase = searchData?.data?.caseDetails[0]
                const isLockedCase =
                  selectedCase?.isCaseLocked === true ||
                  selectedCase?.isCaseLocked
                    ?.toString()
                    ?.toLowerCase()
                    ?.trim() === 'true'

                if (isLockedCase) {
                  navigate('/lockedcase', {
                    state: {
                      searchedTerm:
                        selectedCase?.reference ||
                        selectedCase?.caseNumber ||
                        searchTearm,
                      lockMessage: 'This case is locked and under  review.',
                    },
                  })
                  showLoader(false)
                  setsearchTearm(null)
                  onCleartextBoxValue()
                  return
                }

                setSelectedcaseDetails(selectedCase)
                showLoader(false)
                resetCaseOverviewTabSelectedIndex()
                setChangesMade(false)
                setAdditionalOptionsDisabled(true)
                navigate(
                  `/pcnpage?caseId=${utils?.encryptData(selectedCase?.id)}`
                )
                setRefreshPcnData(true)
                setLastPathName('searchBar')
              } else {
                setSelectedcaseDetails([])
                showLoader(false)
              }
              setsearchTearm(null)
              onCleartextBoxValue()
            }
          } else if (
            searchData?.status === utils?.apiResponseCode?.internalServerError
          ) {
            showToastMessage({
              message:
                (searchData?.data?.validationErrors?.length > 0 &&
                  searchData?.data?.validationErrors[0]?.errorMessage) ||
                searchData?.data?.message,
              status: 'error',
            })
            showLoader(false)
          } else if (
            searchData?.status === utils?.apiResponseCode?.badRequest
          ) {
            showToastMessage({
              message:
                (searchData?.data?.validationErrors?.length > 0 &&
                  searchData?.data?.validationErrors[0]?.errorMessage) ||
                searchData?.data?.message,
              status: 'error',
            })
            showLoader(false)
          } else {
            showToastMessage({
              message:
                searchData?.data?.validationErrors?.length > 0 &&
                searchData?.data?.validationErrors[0]?.errorMessage,
              status: 'error',
            })
            showLoader(false)
          }
          showLoader(false)
        }
      } else {
        getSearchData = async () => {
          const associatedValidation = await getCoreData(
            APIEndPoints?.jobState?.getJobDetails?.method,
            APIEndPoints?.jobState?.getJobDetails?.url
              ?.replace('__JobId__', Number(searchTearm))
              ?.replace('__ContractId__', selectedContract?.contractId || 0),
            null,
            null,
            null,
            false,
            'clampandRemoval'
          )
          if (
            associatedValidation &&
            associatedValidation?.status === utils?.apiResponseCode?.successCode
          ) {
            getDropdownDatas(associatedValidation?.data)
          } else if (
            associatedValidation?.status ===
              utils?.apiResponseCode?.internalServerError ||
            associatedValidation?.status === utils?.apiResponseCode?.badRequest
          ) {
            showToastMessage({
              message: staticValues?.enterValidData,
              status: utils?.toastStatus?.error,
            })
            showLoader(false)
          } else {
            showToastMessage({
              message: associatedValidation?.data?.exceptionMessage,
              status: utils?.toastStatus?.error,
            })
            showLoader(false)
          }
        }
      }

      if (hasChanges) {
        const gobackres = utils?.confirmwindow(
          'Please save your data before switching to another case.'
        )
        if (gobackres) {
          showLoader(true)
          getSearchData()
        } else {
          showLoader(false)
        }
      } else {
        showLoader(true)
        getSearchData()
      }
    }
  }, [searclick])

  const modalclose = () => {
    setState((Prev) => ({
      ...Prev,
      modalOpen: false,
    }))
  }

  const getDropdownDatas = (JobData) => {
    Promise.all([
      getCoreData(
        APIEndPoints?.jobState?.stateTypes?.method,
        APIEndPoints?.jobState?.stateTypes?.url?.replace(
          '__ContractId__',
          JobData?.JobDetail?.ContractId || 0
        ),
        null,
        null,
        null,
        true,
        'clampandRemoval'
      ),
    ])
      .then(([stateLookUpData]) => {
        setJobIndex(0)
        setPoundIndex(0)
        if (JobData) {
          setJobIdData((prev) => {
            return [
              ...prev,
              {
                jobId: JobData?.JobDetail?.Id,
                contractId: JobData?.JobDetail?.ContractId,
              },
            ]
          })
          let stateForJobOrPoundScreen =
            stateLookUpData?.data?.length > 0 &&
            stateLookUpData?.data?.find(
              (stateItems) => stateItems?.id === JobData?.JobDetail?.StateId
            )?.name
          if (
            stateForJobOrPoundScreen === staticValues?.disposal ||
            stateForJobOrPoundScreen ===
              staticValues?.eligibleForDisclaimJobState ||
            stateForJobOrPoundScreen === staticValues?.releasedJobState ||
            stateForJobOrPoundScreen === staticValues?.impoundJobState ||
            (JobData?.PoundDetail !== null && JobData?.PoundDetail?.BayNumber)
          ) {
            setPoundDetails(JobData)
            navigate('/pounddetails')
          } else {
            setJobDetails(JobData)
            setJobStepper('')
            let selectedContractWidget =
              userDataItems?.contract &&
              JSON?.parse(userDataItems?.contract)?.filter((contractData) => {
                return (
                  contractData?.Id === JobData?.JobDetail?.ContractId ||
                  contractData?.Id === staticValues?.superAdminContractId
                )
              })
            let isSelectedUserRoleExist =
              selectedContractWidget &&
              utils?.clampAndRemovalAccessRoles?.includes(
                selectedContractWidget[0]?.RoleName
              )
            if (isSelectedUserRoleExist) {
              setAccessibleUserForClampAndRemoval(true)
            }
            navigate('/jobdetails')
          }

          showLoader(false)
        }
      })
      .catch((error) => {
        showToastMessage({
          message: error?.message || 'An error occurred',
          status: utils?.toastStatus?.error,
        })
        showLoader(false)
      })
  }

  return (
    <div className="searchIcon">
      <Search
        className={
          result?.length === 0 && errMsg === ''
            ? 'childern__hidden'
            : 'childern__visible'
        }
        data-testid="searchbarInput"
        category
        //categoryLayoutRenderer={categoryLayoutRenderer}
        //categoryRenderer={categoryRenderer}
        loading={isLoading}
        onResultSelect={handleResultSelect}
        onSearchChange={handleSearchChange}
        //resultRenderer={resultRenderer}
        results={result}
        value={value || state?.searchName}
        onKeyDown={listenEnter}
        input="text"
        placeholder={utils?.fpnBasedChanges?.globalSearch}
        noResultsMessage={errMsg}
        icon={
          <div className="searchiconmaindiv">
            {value?.toString()?.length > 0 ||
            state?.searchName?.toString()?.length > 0 ? (
              <CloseOutlinedIcon
                onClick={onCleartextBoxValue}
                fontSize="medium"
                data-testid="closeIcon"
              />
            ) : null}
            <img
              width="16"
              height="16"
              className="searchiconimage"
              src={SearchIcon}
              onClick={handleSearchResult}
              data-testid="iconSearch"
            />
          </div>
        }
        fluid
      />

      {state?.modalOpen && state?.dataSource?.length > 0 ? (
        <ReactModal
          searchData={state}
          modalOpen={state?.modalOpen}
          setmodalOpen={modalclose}
          modaltype="SearchBar"
          contractType={selectedContract?.contractType}
        />
      ) : null}
    </div>
  )
}

export default SearchBar
